import { useState } from 'react';
import ProposalService from '../../../services/ProposalService';
import LoadingSpinner from '../../LoadingSpinner/LoadingSpinner';
import Modal from '../../Modal';
import FormMotivoRecusa from '../Action2/FormMotivoRecusa';
import AdditionalInformationComun from './AdditionalInformationComun';
import { ModalPDF } from '../..';

interface IProp {
  proposal: any;
  statusActual: any;
}
const Action7 = ({ proposal, statusActual }: IProp) => {
  const [isLoad, setIsLoad] = useState<boolean>(false);
  const [showPdf, setShowPdf] = useState(false);
  function handleClick(aceito: boolean) {
    if (aceito) {
      Modal.show({
        title: "Informações Adicionais",
        body: <AdditionalInformationComun proposal={proposal} isAccept={true} />,
        showCancel: true,
        showConfirm: false
      });
    } else {
      Modal.show({
        title: "Recusar?",
        body: <FormMotivoRecusa onConfirm={ProposalContract} />,
        showCancel: true,
        showConfirm: false // confirm agora será controlado dentro do form
      });
    }
  }

  function ProposalContract(aceito: boolean, motivo?: string) {
    setIsLoad(true);
    const request = {
      id: proposal.id,
      aceito: aceito,
      motivo: aceito ? 0 : motivo || "0"
    };
    ProposalService.postProposalContract(request)
      .then(() => {
        setIsLoad(false);
        window.location.reload();
      })
      .catch((error) => {
        Modal.show({
          title: "Erro ao enviar proposta",
          body: Modal.getErrorMessage(error, request),
          showCancel: true,
          showConfirm: false,
          onCancelText: "Fechar"
        });
      });
  }

  return (
    <>
      {
        isLoad === true &&
        <LoadingSpinner />
      }
      {(proposal?.proposalFile && showPdf) && (
        <ModalPDF
          fileUrl={proposal?.proposalFile}
          onClose={() => setShowPdf(false)}
          titleType='Proposta'
        />
      )}
      {
        (proposal.idProposalType === 1 && statusActual.idProposalStatus === 6) ?
          <>
            {
              proposal.proposalFile ?
              <button type='button' className='btn btn-outline-primary ms-auto mt-2' style={{marginBottom:15}} onClick={() => { setShowPdf(true) }}>Ver Proposta Readequada</button>
                : <p>- Sem arquivo de Readequação</p>
            }
          </>
          : <></>
      }

      <button className='btn btn-primary btnForm d-block minWidth200' onClick={() => handleClick(true)}>Aceito</button>
      <button className='btn btn-danger mt-2 d-block minWidth200' onClick={() => handleClick(false)}>Recusar Proposta</button>
      <Modal/>
    </>
  )
};

export default Action7;
